import GmvHeader from '../GmvHeader';
import ThumbnailField from '../ThumbnailField';
import ColumnNumberField from '../ColumnNumberField';
import EditNumberInput from '../EditNumberInput';
import MainColumnHeader from '../MainColumnHeader';
import MonthColumnHeader from '../MonthColumnHeader';
import { months, monthsNames } from 'views/Components/Forecast/utils/monhts';
import { events } from 'views/Components/Forecast/utils/events';
import EmptyTable from 'views/Components/Shared/Components/EmptyTable';

// Campos de la tabla
export const fields = [
	{ id: 'pvp', label: 'PVP' },
	{ id: 'tsu', label: 'TSU' },
	{ id: 'mg', label: 'MG%' },
	{ id: 'gmv_local', label: 'GMV Local' },
	{ id: 'gmv_usd', label: 'GMV USD' },
	{ id: 'profit', label: 'Profit' },
	{ id: 'cbm', label: 'CBM' },
];

// Obtiene el id de la fila de la tabla
export const getRowId = (row) => row.product_id;

export function clearRow(row) {
	const newRow = { ...row };

	months.forEach((month) => {
		delete newRow[`${month}-pvp`];
		delete newRow[`${month}-tsu`];
		delete newRow[`${month}-mg`];
		delete newRow['thumbnail'];
	});

	return newRow;
}

const MONTH_FIELDS = ['pvp', 'tsu', 'mg', 'gmv_local', 'gmv_usd'];

const getMonthColumnsDefinition = (month, columnsVisibility, canEdit) => {
	const columnsVisible = MONTH_FIELDS.filter((key) => columnsVisibility[key]);

	const columnsVisibleQty = columnsVisible.length;

	const width = 450 / columnsVisibleQty;

	const lastColumn = columnsVisible[columnsVisible.length - 1];

	return [
		{
			field: `${month}-pvp`,
			headerName: 'PVP',
			headerClassName:
				lastColumn === 'pvp' ? 'border-bottom border-right' : 'border-bottom',
			cellClassName: lastColumn === 'pvp' ? 'border-right' : '',
			renderCell: (params) => (
				<ColumnNumberField
					value={params.value}
					month={month}
					id={params.id}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			renderEditCell: (params) => (
				<EditNumberInput
					row={params.row}
					month={month}
					id={params.id}
					value={params.value}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			width,
			editable: canEdit,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => row?.[month]?.pvp,
		},
		{
			field: `${month}-tsu`,
			headerName: 'TSU',
			headerClassName:
				lastColumn === 'tsu' ? 'border-bottom border-right' : 'border-bottom',
			cellClassName: lastColumn === 'tsu' ? 'border-right' : '',
			// renderCell: (params) => (
			// 	<ColumnTSU month={month} value={params.value} row={params.row} />
			// ),
			// renderEditCell: (params) => (
			// 	<ColumnTSUEdit
			// 		row={params.row}
			// 		month={month}
			// 		id={params.id}
			// 		value={params.value}
			// 		field={params.field}
			// 		api={params.api}
			// 		hasFocus={params.hasFocus}
			// 	/>
			// ),
			renderCell: (params) => (
				<ColumnNumberField
					value={params.value}
					month={month}
					id={params.id}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			renderEditCell: (params) => (
				<EditNumberInput
					row={params.row}
					month={month}
					id={params.id}
					value={params.value}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			width,
			resizable: false,
			sortable: false,
			editable: canEdit,
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => row?.[month]?.tsu,
		},
		{
			field: `${month}-mg`,
			headerName: 'MG%',
			headerClassName:
				lastColumn === 'mg' ? 'border-bottom border-right' : 'border-bottom',
			cellClassName: lastColumn === 'mg' ? 'border-right' : '',
			renderCell: (params) => (
				<ColumnNumberField
					value={params.value}
					month={month}
					id={params.id}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			renderEditCell: (params) => (
				<EditNumberInput
					row={params.row}
					month={month}
					id={params.id}
					value={params.value}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			width,
			resizable: false,
			sortable: false,
			editable: canEdit,
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => row?.[month]?.mg,
		},
		{
			field: `${month}-gmv_local`,
			headerName: 'GMV Local',
			headerClassName:
				lastColumn === 'gmv_local'
					? 'border-bottom border-right header-special'
					: 'border-bottom header-special',
			cellClassName:
				lastColumn === 'gmv_local'
					? 'border-right cell-special'
					: 'cell-special',
			renderHeader: () => <GmvHeader id="gmv_local" />,
			renderCell: (params) => (
				<ColumnNumberField
					value={params.value}
					month={month}
					id={params.id}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			width,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => row?.[month]?.gmv_local,
		},
		{
			field: `${month}-gmv_usd`,
			headerName: 'GMV USD',
			headerClassName:
				lastColumn === 'gmv_usd'
					? 'border-bottom border-right header-special'
					: 'border-bottom header-special',
			cellClassName:
				lastColumn === 'gmv_usd' ? 'border-right cell-special' : 'cell-special',
			renderHeader: () => <GmvHeader id="gmv_usd" />,
			renderCell: (params) => (
				<ColumnNumberField
					value={params.value}
					month={month}
					id={params.id}
					field={params.field}
					api={params.api}
					hasFocus={params.hasFocus}
				/>
			),
			width,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => row?.[month]?.gmv_usd,
		},
		// {
		// 	field: `${month}-profit`,
		// 	headerName: 'Profit',
		// 	headerClassName: 'border-bottom',
		// 	width: 60,
		// 	resizable: false,
		// 	sortable: false,
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	valueGetter: (value, row) => row?.[month]?.profit,
		// 	valueFormatter: (value) => {
		// 		return value ? `$${formatearNumeroConComas(value)}` : '';
		// 	},
		// },
		// {
		// 	field: `${month}-cbm`,
		// 	headerName: 'CBM',
		// 	headerClassName: 'border-bottom border-right',
		// 	cellClassName: 'border-right',
		// 	width: 60,
		// 	resizable: false,
		// 	sortable: false,
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	valueGetter: (value, row) => row?.[month]?.cbm,
		// },
	];
};

const MAIN_FIELDS = ['thumbnail', 'sku', 'brand', 'category_owner'];

const TOTAL_COLUMNS = 4;
const TOTAL_MAIN_COLUMNS_WiDTH = 420;

const getMainColumnsDefinition = (columnsVisibility) => {
	const columnsVisible = MAIN_FIELDS.filter((key) => columnsVisibility[key]);

	const columnsVisibleQty = columnsVisible.length;

	const width = TOTAL_MAIN_COLUMNS_WiDTH / columnsVisibleQty;

	const lastColumn = columnsVisible[columnsVisible.length - 1];

	return [
		{
			field: 'thumbnail',
			headerName: 'Foto',
			headerClassName:
				lastColumn === 'thumbnail'
					? 'border-bottom border-right'
					: 'border-bottom',
			cellClassName: lastColumn === 'thumbnail' ? 'border-right' : '',
			renderCell: (params) => <ThumbnailField imageUrl={params?.value} />,
			width: columnsVisibleQty === TOTAL_COLUMNS ? 90 : width,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'sku',
			headerName: 'SKU',
			headerClassName:
				lastColumn === 'sku' ? 'border-bottom border-right' : 'border-bottom',
			cellClassName: lastColumn === 'sku' ? 'border-right' : '',
			width: columnsVisibleQty === TOTAL_COLUMNS ? 150 : width,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'brand',
			headerName: 'Brand',
			headerClassName:
				lastColumn === 'brand' ? 'border-bottom border-right' : 'border-bottom',
			cellClassName: lastColumn === 'brand' ? 'border-right' : '',
			width: columnsVisibleQty === TOTAL_COLUMNS ? 90 : width,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'category_owner',
			headerName: 'CO',
			headerClassName:
				lastColumn === 'category_owner'
					? 'border-bottom border-right'
					: 'border-bottom',
			cellClassName: lastColumn === 'category_owner' ? 'border-right' : '',
			renderCell: (params) => <ThumbnailField name={params?.value} />,
			width: columnsVisibleQty === TOTAL_COLUMNS ? 90 : width,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			align: 'center',
		},
	];
};

export const getMainColumns = (columnsVisibility, canEdit) => [
	...getMainColumnsDefinition(columnsVisibility),
	...months.flatMap((month) =>
		getMonthColumnsDefinition(month, columnsVisibility, canEdit)
	),
];

const getMonthColumnsFieldNames = (month) => {
	return [
		{
			field: `${month}-pvp`,
		},
		{
			field: `${month}-tsu`,
		},
		{
			field: `${month}-mg`,
		},
		{
			field: `${month}-gmv_local`,
		},
		{
			field: `${month}-gmv_usd`,
		},
		{
			field: `${month}-profit`,
		},
		{
			field: `${month}-cbm`,
		},
	];
};

export const columnGroups = [
	{
		groupId: `Forecast`,
		headerClassName: 'group-header-special',
		renderHeaderGroup: () => <MainColumnHeader />,
		children: [
			// {
			// 	field: '__detail_panel_toggle__',
			// },
			{
				field: 'thumbnail',
			},
			{
				field: 'sku',
			},
			{
				field: 'brand',
			},
			{
				field: 'category_owner',
			},
		],
	},
	...months.map((month) => ({
		groupId: monthsNames[month],
		headerClassName: 'group-header-special',
		renderHeaderGroup: () => (
			<MonthColumnHeader month={month} events={events} />
		),
		children: getMonthColumnsFieldNames(month),
	})),
];

export const slots = {
	noRowsOverlay: EmptyTable,
	noResultsOverlay: EmptyTable,
};

export const pageSizeOptions = [25, 50, 100];

export const initialState = {
	pinnedColumns: {
		left: [
			'__detail_panel_toggle__',
			'thumbnail',
			'sku',
			'brand',
			'category_owner',
			'label',
		],
	},
};

export const dataGridStyles = {
	'& .MuiDataGrid-detailPanel': {
		overflow: 'visible',
	},
	'& .MuiDataGrid-cell': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .border-right': {
		borderRight: '1px solid #E0E0E0',
	},
	'& .border-left': {
		borderLeft: '1px solid #E0E0E0',
	},
	'& .border-bottom': {
		borderBottom: '2px solid #E0E0E0 !important',
	},
	'& .border-top': {
		borderTop: '2px solid #E0E0E0 !important',
	},
	'& .MuiDataGrid-columnHeader--emptyGroup': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .header': {
		backgroundColor: '#f3f4f6',
	},
	'& .header-special': {
		backgroundColor: '#e2e8f0',
	},
	'& .cell-special': {
		backgroundColor: '#f1f5f9',
	},
	'& .cell-pend': {
		backgroundColor: '#FFE0B2 !important',
	},
	'& .editable': {
		color: 'rgba(0, 0, 0, 0.38)',
	},
	'& .group-header-special': {
		height: 'fit-content !important',
		padding: '0 !important',
	},
	'& .group-header-special-color': {
		backgroundColor: '#ccd1e1',
	},
	'& .MuiDataGrid-columnHeaderTitleContainer': {
		border: 'none !important',
	},
	'& .MuiDataGrid-filler': {
		height: 'fit-content !important',
	},
	'& .MuiDataGrid-main': {
		paddingBottom: '16px !important',
	},
	'& .no-padding': {
		padding: '0 !important',
	},
	'& .triangle-top-left-pend': {
		width: '0',
		height: '0',
		borderBottom: '16px solid transparent',
		borderLeft: '16px solid orange',
	},
	'& .triangle-top-left-can': {
		width: '0',
		height: '0',
		borderBottom: '16px solid transparent',
		borderLeft: '16px solid red',
	},
	'& .triangle-bottom-left-can': {
		width: '0',
		height: '0',
		borderTop: '16px solid transparent',
		borderLeft: '16px solid red',
	},
	'& .MuiToolbar-root': {
		padding: '0 !important',
	},
	'& .MuiDataGrid-overlayWrapper': {
		top: 'calc(var(--DataGrid-headersTotalHeight) + 110px) !important',
	},
	'& .MuiDataGrid-overlay': {
		height: 'calc(100vh - 500px) !important',
	},

	height: 'calc(100vh - 218px)',
};
